import { generateCodeChallenge, generateCodeVerifier, generateState } from './pkce';

const SSO_STATE_KEY = 'sso_state';
const SSO_VERIFIER_KEY = 'sso_code_verifier';
const SSO_RETURN_TO_KEY = 'sso_return_to';

const authCentreUrl =
  import.meta.env.VITE_AUTH_CENTRE_URL || 'https://auth.tyaus.com';
const clientId =
  import.meta.env.VITE_AUTH_CENTRE_CLIENT_ID || 'app_tyaus_admin';
const adminUrl =
  import.meta.env.VITE_ADMIN_URL || window.location.origin;

function getRedirectUri(): string {
  return `${adminUrl.replace(/\/$/, '')}/auth/callback`;
}

export async function startSsoLogin(returnTo?: string): Promise<void> {
  const state = generateState();
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  sessionStorage.setItem(SSO_STATE_KEY, state);
  sessionStorage.setItem(SSO_VERIFIER_KEY, codeVerifier);
  sessionStorage.setItem(SSO_RETURN_TO_KEY, returnTo || '/dashboard');

  const params = new URLSearchParams({
    client_id: clientId,
    state,
    code_challenge: codeChallenge,
    redirect_uri: getRedirectUri(),
  });

  window.location.href = `${authCentreUrl}/auth/federated-login?${params.toString()}`;
}

export function consumeSsoSession(): {
  state: string;
  codeVerifier: string;
  returnTo: string;
} | null {
  const state = sessionStorage.getItem(SSO_STATE_KEY);
  const codeVerifier = sessionStorage.getItem(SSO_VERIFIER_KEY);
  const returnTo = sessionStorage.getItem(SSO_RETURN_TO_KEY) || '/dashboard';

  if (!state || !codeVerifier) {
    return null;
  }

  return { state, codeVerifier, returnTo };
}

export function clearSsoSession(): void {
  sessionStorage.removeItem(SSO_STATE_KEY);
  sessionStorage.removeItem(SSO_VERIFIER_KEY);
  sessionStorage.removeItem(SSO_RETURN_TO_KEY);
}

export function getAuthCentreUrl(): string {
  return authCentreUrl;
}
